// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"e3c253f49aacf68e","5763":"4875388ae258a744","6893":"7f131555fc63d541","6974":"cc58948629354eed","7222":"d9245635943e7314","7937":"c43f183a2019a616"}[chunkId] + ".js";
};